import { getCookie } from './util'
import { IFileType } from './constants'

export function calculateBlockSize(size) {
  if (size >= 0 && size <= 128 << 20) {
    return 256 << 10
  }
  if (size > 128 << 20 && size <= 256 << 20) {
    return 512 << 10
  }
  if (size > 256 << 20 && size <= 512 << 20) {
    return 1024 << 10
  }
  return 2048 << 10
}

// 云添加使用的Url上传
async function uploadUrl({
  name = '',
  size = 0,
  url,
  files = [],
  parentId = '',
  kind = IFileType,
  unionId = '',
  require_links = false,
}) {
  let hash = ''
  const createParmas = {
    upload_type: 'UPLOAD_TYPE_URL',
    kind,
    parent_id: parentId,
    name,
    hash,
    size,
    url: {
      url,
      files,
    },
    unionId,
    // 创建文件请求中， 增加"params": { "require_links": "true" } ，表示需要直接返回播放链接(边添加边播模式)
    params: {
      require_links: String(require_links),
    },
  }
  const [err, fileData] = await promiseCreateFile(createParmas)
  if (err) return err
  return fileData
}

// 使用URL进行云添加
async function uploadUrlV2({
  name = '',
  size = 0,
  url,
  files = [],
  parentId = '',
  kind = IFileType,
  unionId = '',
  require_links = false,
}) {
  let hash = ''
  const createParams = {
    upload_type: 'UPLOAD_TYPE_URL',
    kind,
    parent_id: parentId,
    name,
    hash,
    size,
    url: {
      url,
      files,
    },
    unionId,
    // 创建文件请求中， 增加"params": { "require_links": "true" } ，表示需要直接返回播放链接(边添加边播模式)
    params: {
      require_links: String(require_links),
    },
  }
  return promiseCreateFile(createParams)
}

export async function checkUpload(fileId) {
  // 检测断点上传的数据
  let xlUploadCache = store.get(`xlUploadCache-${fileId}`)
  if (xlUploadCache) {
    if (xlUploadCache.fileId === fileId) {
      return xlUploadCache
    }
  }
  return null
}

export async function delUploadStore(fileId) {
  store.remove(`xlUploadCache-${fileId}`)
}

function checkUploadTask(name) {
  // 检测当前上传任务是否存在
  // 或者可使用window全局变量来控制
  let val = getCookie('xlUploadTask')
  val = val ? decodeURIComponent(val) : null
  if (val === name) return true
  return false
}


export default {
  uploadUrl,
  uploadUrlV2,
  checkUploadTask,
  checkUpload,
  delUploadStore,
  calculateBlockSize,
}

export function pubSiIuxS2LlRin3oWQWaFmOOnJzNndc0zo (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./captcha.js').pubufve8ouBVeNUjhzRXPbsoKAw79haK0PY
            const nextPart2 = require('./code-res.js').pubyyy0nOBkFWTYY4shOOjbE1KCLwLu74jB
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubjfiAykEpfd3UKwqAPXG1rzqBeOB8I7r4 (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'ZcmcENsUAaAH2GPOzKxO2Zs', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./qrImg.js').pubm0U02OnfsJ8m1pAqjPf1XJTbSEi1VY06
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubJWVguX7jH2BI8QXNMav6MPv5MygAnotB (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'jwcKZpAq23LYOhDQAXrDZmvpTa0MKSy0cIXL4WnRO4', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./error-message.js').pub40923yUDwTCBq734Mu45JxELmYgnFi2n
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubbySujsOqNVkYNhCrlrvIlc43P859wWCX (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./error-message.js').publAojmh4FkTnkkRS7RTZsxjkxe0oMq9Mq
            const nextPart2 = require('./filters.js').pubhmwNY0Wt7UEOVuraaY2k9LabLXjshY5o
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }export function pubDRrqX2Vha5VSMA6sTBAyvPyCk5XPdt3H (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'PdPi7Y8Oyw3dc3', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./captcha.js').pubHwa6IgCC8GWkl3bphQuD6AQa8VhRhGIC
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubRgMk2H0W9ZV6ydUnwHEx77Sl139gXAdw (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'undefined', salt: 'undefined', end: 'end' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart1 = require('./code-res.js').pubCdO3kUot7SKLni97Q0BrilGTV2m9Sf2x
            const nextPart2 = require('./qrImg.js').pub1GEjJqkTgUSLv1mGCWw3D4vOI8sS3Llk
            return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return md5Str
          }
        }